/////////////// LIB. ///////////////
////////////////////////////////////

import eventbus from "../../../../../app/lib/jGia/jGia/src/eventbus";

////////////// UTIL. ///////////////
////////////////////////////////////

// ...

////////// EVENT HANDLERS //////////
////////////////////////////////////

// ...

////////////// ASSETS //////////////
////////////////////////////////////

const logArgs = { eventName: "init_links", inline: true, disabled: false };
const msgs = {
  start: ["init. links"],
  end: ["init. links", "init. success"],
  no_el: ["init. links", "no valid DOM el. provided"],
};

//////// INIT. METHOD DEF. /////////
////////////////////////////////////

export default function init_links() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { link_home } = this.ref;
  this.logger("init", msgs.start, "action", logArgs);
  if (!this.validate_refEl(link_home)) return this.cancel_featInit(msgs.no_el);

  /////// Home-link click hdl. ///////
  ////////////////////////////////////

  // Prevent default behavior + close all modals when click occurs
  // while already on home || projects page with open modal //

  link_home.addEventListener("click", (e) => {
    const activePage = this.state.activePage;
    const has_openModal = document.body.dataset.hasOpenModal === "true";
    if ((activePage === "home" || activePage === "projects") && has_openModal) {
      eventbus.emit("projectsGrid_close_allModals");
    } else {
      swupInst.navigate("/");
    }
  });

  ///////////// Conclude /////////////
  ////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}
